import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII, SHADOWS } from 'styles/consts'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { Icon } from 'common-components'

export const ExportDropdownContent = styled.div`
  background: ${COLORS.white};
  border-radius: ${RADII.card};
  width: 320px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: ${SHADOWS.menu};
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    box-shadow: none;
  }
`

export const ExportOption = styled.div`
  padding: 16px;
  justify-content: space-between;
  width: 100%;
  border: 1px solid ${COLORS.borderColor};
  border-radius: ${RADII.item};
  cursor: pointer;
  &:hover {
    background: ${COLORS.fill};
    border: 1px solid ${COLORS.borderHover};
    box-shadow: ${SHADOWS.card};
  }
`

export const OptionHeader = styled.h1`
  color: ${COLORS.secondarySemiDark};
  font-size: 16px;
  font-weight: 600;
`

export const OptionDescription = styled.div`
  color: ${COLORS.secondary};
  font-size: 11px;
  font-weight: 500;
`

export const CrownBadgeIcon = styled(Icon)`
  display: inline-flex;
  margin-top: -1px;
`
